


<div class="main_form">


  <mat-accordion>

<mat-expansion-panel  hideToggle #example2 [(expanded)]="isExpanded" class="mat-elevation-z10" >
<mat-expansion-panel-header class="mat-expan">
<mat-panel-title >
<h3 class="header"> Basic Information</h3>
</mat-panel-title>
<i class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example2.expanded"></i>
<i class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example2.expanded"></i>


</mat-expansion-panel-header>
<form [formGroup]="acquisitionForm">

      <!-- <div class="controller">
        <h2 class="title">Basic Information</h2>
        <i class="ti-arrow-circle-down"></i>
      </div> -->

      <div class="forms">

           <div class="the_input">
            <label for="">Group</label>
            <select  formControlName="GroupId"  (change)="onFilterSubGroup($event.target.value)" class="default_input">
              <option *ngFor="let group of groups" [value]="group.id">{{
                group.GroupName
              }}</option>
            </select>
            <div class="alert alert-danger" *ngIf="errorHandling('GroupId', 'required', '') ">
              You must provide <strong>group</strong>
           </div>
          </div>

          <div class="the_input">
            <label for="">Sub Group</label>
            <select  formControlName="SubGroupId"  (change)="onFilterSubSubGroup($event.target.value)" class="default_input">
              <option  *ngFor="let subGroup of filterSubGroup"
              [value]="subGroup.id">{{ subGroup.SubGroupName }}</option>
            </select>
            <div class="alert alert-danger" *ngIf="errorHandling('SubGroupId', 'required')">
              You must provide <strong>sub group</strong>
           </div>
          </div>


          <div class="the_input">
            <label for="">Sub Sub Group</label>
            <select  formControlName="SubSubGroupId"  class="default_input">
              <option   *ngFor="let subSubGroup of filterSubSubGroup"
              [value]="subSubGroup.id">{{ subSubGroup.SubSubGroupName }}</option>
            </select>
            <div class="alert alert-danger" *ngIf="errorHandling('SubSubGroupId', 'required')">
              You must provide <strong>sub sub group</strong>
           </div>
          </div>


          <div class="the_input">
            <label for="">Land Name <sup style="color:red; position:unset; font-size: 1.3vw; line-height: 1;">*</sup></label>
            <input type="text" formControlName="LandName" class="default_input" />
            <!-- <div class="alert alert-danger" *ngIf="errorHandling('LandName', 'required')">
              You must provide <strong>land name</strong>
           </div> -->
          </div>

          <div class="the_input">
            <div class="full-width-field" style="margin-top: 34px; display:flex; align-items: center;">
              <button class="default_secondary-btn history_btn mr-2" *ngIf="showTab" (click)="onLandName()">Previous Name <i class="ti-time"></i></button>

              <mat-radio-group  id="id_number" [disabled]="selectedLandTitle">
              <mat-radio-button checked (change)="onChangeLandCodeGenerator($event.value)" value="Manual" style="margin-right: 10px;">Manual</mat-radio-button>
              <mat-radio-button (change)="onChangeLandCodeGenerator($event.value)" value="Automatic">Auto</mat-radio-button>
              </mat-radio-group>

              </div>

          </div>
          <div class="the_input">
            <label for="">Land Code<sup style="color:red; position:unset; font-size: 1.3vw; line-height: 1;">*</sup></label>
            <input type="text" formControlName="LandCode" class="default_input" />
            <!-- <div class="alert alert-danger" *ngIf="errorHandling('LandCode', 'required')">
              You must provide <strong>land code</strong>
           </div> -->
          </div>


          <div class="the_input">
            <label for="">Land Remark</label>
            <input type="text" formControlName="LandRemarks" class="default_input" />
            <div class="alert alert-danger" *ngIf="errorHandling('LandRemarks', 'required')">
              You must provide <strong>land remarks</strong>
           </div>
          </div>

          <div class="the_input">
            <label for="">Category</label>
            <select  formControlName="CategoryId"  class="default_input">
              <option *ngFor="let category of categories" [value]="category.id">{{
                category.CategoryName
              }}</option>
            </select>
            <div class="alert alert-danger" *ngIf="errorHandling('CategoryId', 'required')">
              You must provide <strong>category</strong>
           </div>
          </div>

            <div class="the_input">
              <label for="">Accountable FXN</label>
              <select  formControlName="AccountableFunctionId"  class="default_input">
                <option *ngFor="let accountableFn of accountableFunctions"
                [value]="accountableFn.id">{{ accountableFn.AccountableFunctionName }}</option>
              </select>
            </div>


          <div class="the_input">
            <label for="">Remark</label>
            <textarea class="default_input" placeholder="Enter Remarks " formControlName="LandEndUseRemarks" ></textarea>
            <div class="alert alert-danger" *ngIf="errorHandling('LandEndUseRemarks', 'required')">
              You must provide <strong>remarks</strong>
           </div>
          </div>

          <div class="the_input">
            <button class="default_primary-button" type="submit" (click)="onSubmit(acquisitionForm.getRawValue())">Save</button>
          </div>


      </div>



</form>


</mat-expansion-panel>

  </mat-accordion>
</div>
<div class="other_contents">

    <mat-tab-group class="ta" [disableRipple]=true [(selectedIndex)]="selectedTabIndex" #tabGroup (selectedTabChange)="tabChanged($event)"  *ngIf="showTab">
     <ng-container *ngFor="let activity of activities">
      <mat-tab class="tab" *ngIf="activity?.activityName === 'basicdata' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label class="tab">
          <mat-icon class="example-tab-icon">info</mat-icon>
           Basic Data
        </ng-template>
        <form [formGroup]="acquisitionForm">
        <div class="contents">
          <!-- BASIC DATA=========================BASIC DATA=================BASIC DATA===========BASIC DATA -->
          <div class="basic_data tab_content" id="content1" data-tab="1">
            <div class="contain">
              <div class="the_input">
                <label for="">Acquisition Date</label>
                <input type="date" (input)="onAcquisitionDate($event.target.value)" formControlName="AcquisitionDate" class="default_input" />
              </div>
              <div class="the_input">
                <label for="">Expiration Date</label>
                <input type="date" (input)="onExpirationDate($event.target.value)" formControlName="ExpirationDate" class="default_input" />
              </div>
              <div class="the_input">
                <label for="">Duration (Yrs)</label>
                <input type="number" (input)="onDuration($event.target.value)" formControlName="Duration" class="default_input" />
              </div>
              <div class="the_input">
                <label for="">Acq. Total Cost</label>
                <input type="number" formControlName="TotalCost" class="default_input" />
              </div>

              <div class="the_input">
                <label for="">Currency</label>
                <select  formControlName="CurrencyId" class="default_input">
                  <option  *ngFor="let currency of currencies"
                  [value]="currency.id">{{ currency.CurrencyName }}</option>
                </select>
              </div>
              <div class="the_input">
                <label for="">GIS Area</label>
                <input formControlName="TotalArea" type="number" class="default_input">
             </div>

             <div class="the_input">
                <label for="">Legal Area</label>
                <input (input)="onInput($event.target.value)" formControlName="RecTotalArea" type="number" class="default_input">
             </div>

              <div class="the_input">
                <label for="">Measure</label>
                <select  (change)="onMeasure($event.target.value)" formControlName="MeasureId" class="default_input">
                  <option  *ngFor="let measure of measures"
                  [value]="measure.id">{{ measure.MeasureName }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Acquisition Type</label>
                <select formControlName="AcquisitionTypeId" class="default_input">
                  <option  *ngFor="let acquisitionType of acquisitionTypes"
                  [value]="acquisitionType.id">{{ acquisitionType.AcquisitionTypeName }}</option>
                </select>
              </div>

              <!-- MEASUREMENT CONVERSION==================================== MEASUREMENT CONVERSION============ -->
              <cradua-measurement-conversion-table [selectedLandTitle]="acquisitionForm.value">

              </cradua-measurement-conversion-table>

            </div>

            <div class="second_part">

              <div class="the_input">
                <label for="">Land Use Status</label>
                <select formControlName="LandUseStatusId" class="default_input">
                  <option  *ngFor="let landUse of landUseStatus"
                  [value]="landUse.id">{{ landUse.LandUseStatusName }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Divestment</label>
                <select   formControlName="DivestmentStatusId" class="default_input">
                  <option *ngFor="let divest of divestment"
                  [value]="divest.id">{{ divest.DivestmentStatusName }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Right Held</label>
                <select   formControlName="RightHeldId" class="default_input">
                  <option *ngFor="let rightH of rightHeld"
                  [value]="rightH.id">{{ rightH.RightHeldName }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Purpose</label>
                <select formControlName="PurposeId" class="default_input">
                  <option *ngFor="let purpose of purposes"
                  [value]="purpose.id">{{ purpose.PurposeName  }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Terrain</label>
                <select formControlName="TerrainId" class="default_input">
                  <option  *ngFor="let terrain of terrains"
                  [value]="terrain.id">{{ terrain.TerrainName  }}</option>
                </select>
              </div>

              <div class="the_input">
                <label for="">Banking Status</label>
                <select formControlName="BankingStatus_BankingStatusId" class="default_input">
                  <option  *ngFor="let banking of bankingStatus"
                  [value]="banking.id">{{ banking.BankingStatusName }}</option>
                </select>
              </div>



            </div>

            <div class="the_input" style="text-align: center; width:100%;">
              <button class="default_primary-button" *ngIf="activity?.activitySelectedValue === 'readwrite'" (click)="onSubmit(acquisitionForm.getRawValue())">Save</button>
              <button type="submit" class="default_secondary-btn justify-content-center align-center" (click)="emitTask.emit('list')" type="submit">&larr; Back to list </button>

            </div>
          </div>
          </div>

 </form>
      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'landparcellation' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">landscape</mat-icon>
           Land Parcellation
        </ng-template>

      <cradua-land-parcellation
      [selectedLandTitle]="selectedLandTitle"
      [purposes]="purposes"
      [measures]="measures"
      [landParcels]="landParcels"
      [activitySelectedValue]="activity?.activitySelectedValue"
      [measuringFactors]="measuringFactors"
      [appConfigs]="appConfigs"
      (emitSave)="onEmitLandParcel($event)"
      *ngIf="selectedLandTitle"
      ></cradua-land-parcellation>

      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'surveydata' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">analytics</mat-icon>
           Survey Data
        </ng-template>
  <div class="survey_data tab_content" id="content3" data-tab="3">
    <form [formGroup]="acquisitionForm">
      <div class="top">
        <div class="input">
          <label for="">Survey Drawing No/Map </label>
          <input type="text" formControlName="SurveyDrawingNoMap" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">URL of Drawing </label>
          <input type="text" formControlName="UrlOfDrawing"  class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Survey Date</label>
          <input type="date" formControlName="SurveyDate" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Select Datum</label>
          <select  formControlName="DatumId" class="default_input reference-form">
            <option  *ngFor="let geoDatum of geoDatums"
            [value]="geoDatum.id">{{ geoDatum.DatumName }}</option>
          </select>
        </div>
      </div>

      <div class="coordinate">
        <div class="left">
          <div class="one">
            <p>Latitude:</p>
            <div class="input">
              <label for="">Degree</label>
              <input type="number" formControlName="PobLatitudeDegree" class="default_input reference-form" />
            </div>
            <div class="input">
              <label for="">Minute</label>
              <input type="number" formControlName="PobLatitudeMin" class="default_input reference-form" />
            </div>
            <div class="input">
              <label for="">Second</label>
              <input type="number" formControlName="PobLatitudeSec" class="default_input reference-form" />
            </div>
          </div>
          <div class="two">
            <p>Longitude:</p>
            <div class="input">
              <label for="">Degree</label>
              <input type="number" formControlName="PobLongitudeDegree" class="default_input reference-form" />
            </div>
            <div class="input">
              <label for="">Minute</label>
              <input type="number" formControlName="PobLongitudeMin" class="default_input reference-form" />
            </div>
            <div class="input">
              <label for="">Second</label>
              <input type="number" formControlName="PobLongitudeSec" class="default_input reference-form" />
            </div>
          </div>
        </div>
        <div class="right">
          <div class="input">
            <label for="">Easting</label>
            <input type="number" formControlName="Easting" class="default_input reference-form" />
          </div>
          <div class="input">
            <label for="">Northing</label>
            <input type="number" formControlName="Northing" class="default_input reference-form" />
          </div>
        </div>
      </div>
      <div class="acquisition_submit">
        <button type="submit" class="default_primary-button" *ngIf="activity?.activitySelectedValue === 'readwrite'" (click)="onSubmit(acquisitionForm.getRawValue())" type="submit">Submit  &rarr;</button>
       </div>
       </form>
  </div>


      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'geospatial' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">public</mat-icon>
          GeoSpatial

        </ng-template>

        <cradua-geo-spatial
        [selectedLandTitle]="selectedLandTitle"
        [appConfigs]="appConfigs"
        [purposes]="purposes"
        ></cradua-geo-spatial>
      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'assetlocation' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">location_on</mat-icon>
          Asset Location
        </ng-template>


<cradua-asset-location
[selectedLandTitle]="selectedLandTitle"
[states]="states"
[lgas]="lgas"
[communities]="communities"
[activitySelectedValue]="activity?.activitySelectedValue"
[divisions]="divisions"
[assetLocations]="assetLocations"
[isLoadingAssetLocation]="isLoadingAssetLocation"
(emitSave)="onEmitAssetLocation($event)"
(emitDelete)="onEmitAssetLocationDelete($event)"
>

</cradua-asset-location>

      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'storagelocation' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">storage</mat-icon>
          Storage Location
        </ng-template>

      <cradua-storage-location
        [cabinetShelfRefs]="cabinetShelfRefs"
        [rackTrayRefs]="rackTrayRefs"
        [activitySelectedValue]="activity?.activitySelectedValue"
        [fileLocations]="fileLocations"
        [selectedLandTitle]="selectedLandTitle"
        (emitSave)="onSaveStorageLocation($event)"
      >

      </cradua-storage-location>
      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'documents' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">map</mat-icon>
           Documents
        </ng-template>
        <cradua-document
        [selectedLandTitle]="selectedLandTitle"
        [documentTypeCodes]="documentTypeCodes"
        [activitySelectedValue]="activity?.activitySelectedValue"
        [documentTypes]="documentTypes"
        [securityClassifications]="securityClassifications"
        [fileLocations]="fileLocations"
        [fetchDocuments]="fetchDocuments"
        [isLoadingDocument]="isLoadingDocument"
        [progress]="progress"
        [error]="error"
        [isInProgress]="isInProgress"
        [isReady]="isReady"
        [hasFailed]="hasFailed"
        (emitUpload)="onUploadFile($event)"
        (emitSaveManyDoc)="onSaveManyDoc($event)"
        (emitCancel)="onCancelUpload($event)"
        (emitReset)="onResetUpload($event)"
        ></cradua-document>

      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'addressbook' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">contacts</mat-icon>
           Address Book
        </ng-template>
       <cradua-address-book
       [selectedLandTitle]="selectedLandTitle"
       [states]="states"
       [lgas]="lgas"
       [activitySelectedValue]="activity?.activitySelectedValue"
       [communities]="communities"
       [banks]="banks"
       [titles]="titles"
       [addressBooks]="addressBooks"
       [isLoadingAddressBook]="isLoadingAddressBook"
       (emitAddressBook)="onSearchAddressBook($event)"
       (emitSaveAddressBook)="onSaveAddressBook($event)"
       (emitClearAddressBook)="onEmitClearAddressBook($event)"

       >
       </cradua-address-book>
      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'lessors' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">group_add</mat-icon>
           Lessor(s)
        </ng-template>
        <cradua-lessor
        [activitySelectedValue]="activity?.activitySelectedValue"
        [ownershipTypes]="ownershipTypes"
        [lessorRepTypes]="lessorRepTypes"
        [terrains]="terrains"
        [measures]="measures"
        [banks]="banks"
        [lessorInfos]="lessorInfos"
        [lessorAreaMakers]="lessorAreaMakers"
        [lessorRepresentatives]="lessorRepresentatives"
        [lessorStakeholders]="lessorStakeholders"
        [individualAcreages]="individualAcreages"
        [addressBooks]="addressBooks"
        [selectedLandTitle]="selectedLandTitle"
        [isLoadingAddressBook]="isLoadingAddressBook"
        [isLoadingLessorAreaMaker]="isLoadingLessorAreaMaker"
        [isLoadingLessorRepresentative]="isLoadingLessorRepresentative"
        [isLoadingLessorStakeholder]="isLoadingLessorStakeholder"
        [isLoadingIndividualAcreages]="isLoadingIndividualAcreages"
        (emitAddressBook)="onEmitAddressBookLessor($event)"
        (emitCreateAddressBook)="onEmitCreateAddressBook($event)"
        (emitLessorAreaMaker)="onEmitLessorAreaMaker($event)"
        (emitLessorAreaMakerDelete)="onEmitLessorAreaMakerDelete($event)"
        (emitLessorRepresentative)="onEmitLessorRepresentative($event)"
        (emitLessorStakeholder)="onEmitLessorStakeholder($event)"
        (emitLessorRepresentativeDelete)="onEmitLessorRepresentativeDelete($event)"
        (emitLessorStakeholderDelete)="onEmitLessorStakeholderDelete($event)"
        (emitIndividualAcreages)="onEmitIndividualAcreages($event)"
        (emitIndividualAcreagesDelete)="onEmitIndividualAcreagesDelete($event)"
        (emitLessorInfoDelete)="onEmitLessorInfoDelete($event)"

        ></cradua-lessor>

      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'payment' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">group_add</mat-icon>
           Payment
        </ng-template>
        <cradua-payment-container
        [PaymentType]="PaymentType"
        [ownershiptypes]="ownershipTypes"
         [uoms]="measures"
         [quantums]="quantums"
         [terrains]="terrains"
         [addressbooks]="addressBooks"
         [lessorInfos]="lessorInfos"
         [banks]="banks"
         [lessorRepTypes]="lessorRepTypes"
         [individualAcreages]="individualAcreages"
         [lessorRepresentatives]="lessorRepresentatives"
         [lessorStakeholders]="lessorStakeholders"
         [LandTitleSerialNo]="selectedLandTitle.id"
         *ngIf="
         !isLoadingAddressBook &&
         !isLoadingLessorRepresentative &&
         !isLoadingLessorInfo &&
         !isLoadingIndividualAcreages &&
         !isLoadingLessorStakeholder
         "
        ></cradua-payment-container>
      </mat-tab>

      <mat-tab *ngIf="activity?.activityName === 'cofo' && activity?.activitySelectedValue !== 'noaccess'">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">group_add</mat-icon>
           C of O
        </ng-template>


       <form [formGroup]="acquisitionForm">
        <div class="contents">
          <div class="basic_data tab_content" id="content1" data-tab="1">
          <h2 class="title">Register CofO</h2>
          <div class="contain">
            <div class="the_input">
              <label for="">CofO Ref No.</label>
              <input type="text" formControlName="CofONumber" class="default_input" />
            </div>

            <div class="the_input">
              <label for="">CofO Status</label>
              <select formControlName="CofOStatusId" class="default_input">
                <option *ngFor="let status of cofOStatus"
                [value]="status.id">{{ status.CofOStatusName }}</option>
              </select>
            </div>

            <div class="the_input">
              <label for="">CofO Date Issued</label>
              <input type="date" formControlName="CofODate" class="default_input" />
            </div>

            <div class="the_input">
              <label for="">COfO Expiration Date</label>
              <input type="date" formControlName="COfOExpirationDate" class="default_input" />
            </div>

            <div class="the_input">
              <label for="">CofO Remarks</label>
              <input type="text" formControlName="CofORemarks" class="default_input" />
            </div>

            <div class="acquisition_submit">
              <button type="submit" *ngIf="activity?.activitySelectedValue === 'readwrite'" class="default_primary-button" (click)="onSubmit(acquisitionForm.getRawValue())" type="submit">Submit  &rarr;</button>
             </div>
          </div>
        </div>
        </div>
 </form>


 <form [formGroup]="acquisitionForm">
  <div class="contents">
    <div class="basic_data tab_content" id="content1" data-tab="1">
    <h2 class="title">Revoke CofO</h2>
    <div class="contain">
     <div class="the_input">
       <label for="">CofO Revocation Date</label>
       <input type="date" formControlName="CofORevocationDate" class="default_input" />
     </div>

     <div class="the_input">
       <label for="">Reasons For Revocation</label>
       <input type="text" formControlName="CofOReasonsForRevocation" class="default_input" />
     </div>


   </div>
   <div class="acquisition_submit">
    <button type="submit" class="default_primary-button" (click)="onSubmit(acquisitionForm.getRawValue())" type="submit">Submit  &rarr;</button>
   </div>
 </div>
 </div>
</form>
      </mat-tab>

    </ng-container>
    </mat-tab-group>

  </div>

